import React from "react";
import { useQuery } from "@apollo/client/react";
import { INVENTORY_REQUEST_QUERY } from "src/constants/graphql/queries";
import OutboundChargesSummaryModal from "src/views/inventory/requests/orders/OutboundChargesSummaryModal";
import StatusDialog from "./StatusDialog";

export default function OutboundChargesSummaryModalWrapper({ outboundChargesSummaryId, onClose }) {
  const { data: inventoryRequestData, loading, error } = useQuery(INVENTORY_REQUEST_QUERY, {
    variables: { id: outboundChargesSummaryId },
    skip: !outboundChargesSummaryId,
  });

  const inventoryRequest = inventoryRequestData?.inventoryRequest;

  if (!loading && error) {
    return (
      <StatusDialog
        title="Failed to load Outbound Charges Summary"
        message="You may not have access to view this order, or it no longer exists."
        onClose={onClose}
      />
    );
  }

  if (inventoryRequest) {
    return (
      <OutboundChargesSummaryModal
        inventoryRequest={inventoryRequest}
        onClose={onClose}
        isSimpleCheckoutContractWarehousesMode={false}
      />
    );
  }

  return null;
}
